import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { UserManagementServiceService } from '../user-management-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { ActivatedRoute , Router} from '@angular/router';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';


@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  ADMIN_ROLE = 1;

  public userForm !: FormGroup ;
  countrys: any = [];
  sectorNames: any = [];
  msmeNames: any = [];
  userRoles: any = [];
  userId = '';
  adminData: any = JSON.parse(sessionStorage.getItem('userdata') || '{}');
  showCountryDropdown = false;
  selectedCountry: any;

  maxEmployeeCount = 1000000;

  userAllData: any;
  userEmailId = '';
  currentMode: any = 'edit';
  selectedLevel: any;

  constructor(
    private formBuilder: FormBuilder,
    private userManagementService: UserManagementServiceService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonServiceService,
  ) {
    this.createUserForm();
    this.getUserRoleDetails();
    this.getCountryDetails();
    this.getSectorDetails();
    this.getMsmeDetails();
  }

  @ViewChild('userRole') select: MatSelect | undefined;

  preventKeyboardInput(event: KeyboardEvent): void {
    if (event) {
    return;
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(queryParams => {
      this.currentMode = queryParams?.mode;

    });
    this.userId = this.route.snapshot.params.id;
    if (this.userId){
      setTimeout(() => {
        this.prifieldMethod(this.userId);
      }, 1000);
    }

    this.commonService.formGetMethod('msme-classification/list', { order: 'DESC', key: 'max_employee_count' }).subscribe((res: any) => {
      if (res && res.data && res.data.length) {
        this.maxEmployeeCount = res.data[0].max_employee_count;
      }
    });
  }
  createUserForm(): void {
    this.userForm = this.formBuilder.group({
      name: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        userRole: ['', Validators.required],
        sectorName: [''],
        countryName: [''],
        msmeName: [''],
        employeeCount: [''],
    });
}

async getCountryDetails(): Promise<void> {
  await this.userManagementService.countryDetails().subscribe((res: any) => {
    if (res.success){
      if (this.adminData?.userlevel_id !== this.ADMIN_ROLE){
        res.data = res.data.filter((response: any) => this.adminData?.country_id ? response.id === this.adminData?.country_id : true);
      }
      this.countrys = res.data;
    }
  }, (error: any) => {
    this.openSnackBar([error?.message || 'Failed !'] , '');
  });

}

async getSectorDetails(): Promise<void> {
  await this.userManagementService.sectorNameDetails().subscribe((res: any) => {
    if (res.success){
      if (this.adminData?.userlevel_id !== this.ADMIN_ROLE){
        res.data = res.data.filter((response: any) => this.adminData?.sector_id ? response.id === this.adminData?.sector_id : true);
      }
      this.sectorNames = res.data;
    }
  }, (error: any) => {
    this.openSnackBar([error?.message || 'Failed !'] , '');
  });

}

async getMsmeDetails(): Promise<void> {
  await this.userManagementService.msmeNameDetails().subscribe((res: any) => {
    if (res.success){
      if (this.adminData?.userlevel_id !== 1){
        res.data = res.data.filter((response: any) => this.adminData?.msme_id ? response.id === this.adminData?.msme_id : true);
      }
      this.msmeNames = res.data;
    }
  }, (error: any) => {
    this.openSnackBar([error?.message || 'Failed !'] , '');
  });

}

async getUserRoleDetails(): Promise<void> {
  const currentRoleId: number = this.adminData?.userlevel_id === this.ADMIN_ROLE ? 0 : this.adminData?.userlevel_id;
  this.userManagementService.UserRoleDetails(currentRoleId).subscribe((res: any) => {
    if (res.success){
      this.userRoles = res.data;
    }
  }, (error: any) => {
    this.openSnackBar([error?.message || 'Failed !'] , '');
  });

}

onEmployeeCountBlur(): void {
  if (this.userForm?.controls.employeeCount?.value > this.maxEmployeeCount) {
    this.userForm.get('employeeCount')?.setErrors({ maxEmployeeCountError: true });
  }
}

  createUser(): void {
    if (this.userForm?.invalid){
      this.openSnackBar(['All field are required !!'], '', 'warning');
    }
    const payload = {
      name : this.userForm?.controls.name.value,
      email : this.userForm?.controls.email.value,
      country_id : this.showCountryDropdown && this.userForm?.controls.countryName ? this.userForm?.controls.countryName.value?.id : null,
      sector_id : this.userForm?.controls.sectorName ? this.userForm?.controls.sectorName.value?.id : null,
      msme_id : this.userForm?.controls.msmeName ? this.userForm?.controls.msmeName.value?.id : null,
      employeeCount : this.userForm?.controls.employeeCount ? this.userForm?.controls.employeeCount.value?.id : null,
      userlevel_id: this.selectedLevel,
      role_id: this.userForm?.controls.userRole.value?.id,
      createdBy: this.adminData ? this.adminData?.id : '',
    };

    if (this.userId){
      this.userManagementService.updateUser(this.userId, payload).subscribe((res: any) => {
        if (res.success){
        this.getTargetterUserData(res?.message, payload);
        }
      }, (error: any) => {
        this.openSnackBar([error?.message || 'Failed !'] , '');
      });
    }
    else{
      this.userManagementService.createUser(payload).subscribe((res: any) => {
        if (res.success){
          this.openSnackBar([res?.message || 'Success !'] , '', 'success');
        }
        this.router.navigate(['/manage-user']);
      }, (error: any) => {
        this.openSnackBar([error?.message || 'Failed !'] , '');
      });
    }
  }

  getTargetterUserData(respMsg: any, payloadData: any): void {
    const endpoint = `/admin/submission?data.email=${this.userEmailId}`;
    const payload = {
      endpoint,
      headers: {
        'Content-Type': 'application/json'
      },
      requestBody: {},
      method: 'GET'
    };
    this.userManagementService.targettedUserData(payload).subscribe((res: any) => {
      if (res.length){
        this.userAllData = res;
        this.updateUserData(this.userAllData, respMsg, payloadData);
      }
    });
  }

  updateUserData(userData: any, respMsg: any, payloadData: any): void {
    const endpoint = `/admin/submission/${userData[0]._id}`;
    const payload = {
      endpoint,
      headers: {
        'Content-Type': 'application/json'
      },
      requestBody: {
        data: {
          email: payloadData?.email,
    }
    },
      method: 'PUT'
    };
    this.userManagementService.updateUserForIpsa(payload).subscribe(res => {
        if (res){
          this.openSnackBar([respMsg || 'Created Successfully '] , '', 'success');
          this.router.navigate(['/manage-user']);
        }
      });
  }

  get f(): any {
    return this.userForm.controls;
  }

  countryChangeHandler(event: MatSelectChange): void {
    this.selectedCountry = event.value.id;

    if (event?.value?.id){
      this.sectorNames = [];
      this.msmeNames = [];
      this.userForm.patchValue({
        sectorName: [],
        msmeName: []
      });
    }
  }
  sectorChangeHandler(event: MatSelectChange): void {
    if (event?.value?.id){

      this.msmeNames = [];
      this.userForm.patchValue({
        msmeName: []
      });
    }
  }
   async prifieldMethod(userId: string): Promise<void> {
     await this.userManagementService.getUserDataById(userId).subscribe((res: any) => {
      if (res.success){
        res = JSON.parse(JSON.stringify(res?.data));
        this.userEmailId = res[0]?.email;
        this.selectedLevel = res[0]?.userlevel_id;
        this.dropdownDataPrefield(res[0]);


      }
    }, (error: any) => {
      this.openSnackBar([error?.message || 'Failed !'] , '', '');
    });
  }
  dropdownDataPrefield(data: any): void {

    const countryDetail = this.countrys.find((el: any) => el.id === data?.country_id);
    const sectorDetail = this.sectorNames.find((el: any) => el.id === data?.sector_id);
    const msmeDetail = this.msmeNames.find((el: any) => el.id === data?.msme_id);
    const roleDetail = this.userRoles.find((el: any) => el.id === data?.role_id);

    this.userForm.patchValue({
        ipName: sectorDetail,
        countryName: countryDetail,
        sectorName: sectorDetail,
        msmeName: msmeDetail,
        userRole: roleDetail,
        name: data.name,
        email:  data.email,
        employeeCount: data.employeeCount,
    });
  }
  openSnackBar(message: any, action = '', className= 'parmary'): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: [className]
  });
}

numberOnly(event: any): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}

}
